export default __webpack_public_path__ + "static/media/academicV2.22210d09.svg";